const DEFAULT_ITEMS = ["#GoldVision", "Trading", "Mindset", "Community"];

export default function Marquee({ items = DEFAULT_ITEMS }) {
  const chunk = (
    <>
      {[...items, ...items].map((t, i) => (
        <span key={i} className="inline-flex items-center gap-11">
          {t}
          <span style={{ color: "var(--mm-gold)", opacity: 0.7 }}>✦</span>
        </span>
      ))}
    </>
  );
  return (
    <div className="marquee" data-testid="marquee-strip" aria-hidden="true">
      <div className="marquee-track">
        <div className="marquee-chunk">{chunk}</div>
        <div className="marquee-chunk">{chunk}</div>
      </div>
    </div>
  );
}
